export default "__VITE_ASSET__DwdTx7aD__"